import { compose } from 'redux';

import { COMMON_DATE_FORMAT } from 'constants/date';
import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

import { PropertyAndLoanTestIds } from '../../../../PropertyAndLoan.testIds';

import { SELL_SIDE_LOCK_NUMBER_MAX_LENGTH, SellSideLockFieldName } from './SellSideLock.constants';

const getLockDateField = ({ fieldName, label, dataTestId, disabled }) => ({
  fieldId: fieldName,
  type: FieldType.DATE,
  nameInModel: `sellSideLock.${fieldName}`,
  inputProps: {
    type: FieldInputType.DATE,
    label,
    required: false,
    disabled,
    variant: 'outlined',
    format: COMMON_DATE_FORMAT,
    widthInColumns: 2,
    dataTestId,
  },
});

const getNumberField = ({ fieldName, label, dataTestId, disabled }) => ({
  fieldId: fieldName,
  type: FieldType.INPUT,
  nameInModel: `sellSideLock.${fieldName}`,
  inputProps: {
    type: FieldInputType.TEXT,
    label,
    required: false,
    disabled,
    variant: 'outlined',
    maxLength: SELL_SIDE_LOCK_NUMBER_MAX_LENGTH,
    widthInColumns: 2,
    dataTestId,
  },
});

export const getSellSideLockConfig = compose(
  fillConfigFieldsWithKeys,
  ({ investorsOptions, disabled, investorPriceHelperText }) => ({
    groups: [
      {
        type: FieldType.GROUP,
        key: 'sell-side-lock',
        fields: [
          {
            fieldId: SellSideLockFieldName.INVESTOR_ID,
            type: FieldType.SELECT,
            nameInModel: `sellSideLock.${SellSideLockFieldName.INVESTOR_ID}`,
            inputProps: {
              label: 'Investor',
              required: false,
              disabled,
              variant: 'outlined',
              options: investorsOptions,
              widthInColumns: 2,
              dataTestId: PropertyAndLoanTestIds.SELL_SIDE_LOCK_FORM_INVESTOR_SELECT,
            },
          },
          getNumberField({
            fieldName: SellSideLockFieldName.INVESTOR_LOAN_NUMBER,
            label: 'Investor Loan Number',
            disabled,
            dataTestId: PropertyAndLoanTestIds.SELL_SIDE_LOCK_FORM_INVESTOR_LOAN_NUMBER_INPUT,
          }),
          getNumberField({
            fieldName: SellSideLockFieldName.COMMITMENT_NUMBER,
            label: 'Commitment Number',
            disabled,
            dataTestId: PropertyAndLoanTestIds.SELL_SIDE_LOCK_FORM_COMMITMENT_NUMBER_INPUT,
          }),
          {
            fieldId: 'investorPrice',
            type: FieldType.INPUT,
            nameInModel: 'profitAndLoss.netSellPrice',
            inputProps: {
              type: FieldInputType.FLOAT,
              label: 'Investor Price',
              required: false,
              disabled,
              variant: 'outlined',
              allowNegative: false,
              decimalScale: 3,
              decimalSeparator: '.',
              helperText: investorPriceHelperText,
              widthInColumns: 2,
              dataTestId: PropertyAndLoanTestIds.SELL_SIDE_LOCK_FORM_INVESTOR_PRICE_INPUT,
            },
          },
          getLockDateField({
            fieldName: SellSideLockFieldName.INVESTOR_LOCK_DATE,
            label: 'Investor Lock Date',
            disabled,
            dataTestId: PropertyAndLoanTestIds.SELL_SIDE_LOCK_FORM_LOCK_DATE_INPUT,
          }),
          getLockDateField({
            fieldName: SellSideLockFieldName.INVESTOR_LOCK_EXPIRATION,
            label: 'Investor Lock Expiration',
            disabled,
            dataTestId: PropertyAndLoanTestIds.SELL_SIDE_LOCK_FORM_LOCK_EXPIRATION_INPUT,
          }),
        ],
      },
    ],
  }),
);

export const sellSideLockSectionFieldsKeys = Object.values(SellSideLockFieldName).map(
  fieldName => `sellSideLock.${fieldName}`,
);
